import { grayscaleList, delGrayscale } from './request';
import whiteModel from './whiteModel.vue';
import { customerResource } from './../customerManage/request';
export default {
  components: {
    whiteModel
  },
  data() {
    return {
      whiteShow: false,
      form: {
        mobile: '',
        customerId: undefined
      },
      columns: [{
        slots: {
          title: 'id'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '用户名'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '手机号'
        },
        dataIndex: 'mobile',
        key: 'description',
        align: 'center'
      }, {
        slots: {
          title: '归属客户'
        },
        dataIndex: 'customerName',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '应用'
        },
        dataIndex: 'applicationInfo',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '添加时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 100,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      customerList: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
    customerResource().then(res => {
      this.customerList = res;
    });
  },
  methods: {
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      grayscaleList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleDelete(val) {
      console.log(val);
      delGrayscale({
        grayscaleId: val.grayscaleId
      }).then(res => {
        this.$message.success(this.$t('删除成功'));
        this.getDataFun();
      });
    },
    addFun() {
      this.whiteShow = true;
      this.$nextTick(() => {
        this.$refs.whiteFrom.init();
      });
    },
    handleOk() {
      this.whiteShow = false;
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};